import { Icon } from "../Icons";

export function WhoWeAre({ onContactClick }: { onContactClick: () => void }) {
  return (
    <section className="section" id="about">
      <div className="section-inner">
        <div
          className="about-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1.3fr",
            gap: 80,
            alignItems: "start",
          }}
        >
          <div>
            <div className="eyebrow">07 · Who's behind this</div>
            <img
              src="/katenaria-logo.svg"
              alt="Katenaria Inc."
              width={128}
              style={{ display: "block", marginTop: 18 }}
            />
          </div>
          <div>
            <p className="lede" style={{ maxWidth: 620 }}>
              We build native, deterministic runtimes for industrial data. Coprocessor brings a
              high-performance C++ signal engine into Ignition so teams can run real-time math next
              to the tags they already operate.
            </p>
            <div style={{ display: "flex", gap: 14, marginTop: 24, flexWrap: "wrap" }}>
              <a href="https://github.com/rtbot-dev" target="_blank" rel="noreferrer" className="btn btn-secondary">
                GitHub <Icon.External style={{ opacity: 0.6 }} />
              </a>
              <button onClick={onContactClick} className="btn btn-ghost">
                Contact
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
